/** Cross-tab refresh when Orders stay mounted but hidden (e.g. after quotation → order convert). */

export const PANEL_DATA_CHANGED = "thaai-panel-data-changed";

export type PanelDataChange = {
  orders?: boolean;
  /** Refetch orders from page 1 (new order usually appears at top). */
  resetOrdersPage?: boolean;
  quotations?: boolean;
  invoices?: boolean;
};

export function notifyPanelDataChanged(detail: PanelDataChange) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(PANEL_DATA_CHANGED, { detail }));
}
